import { axios, Response } from '../index'

const deletePersonaFolderGroup = (folderId: string): Response<null> => {
  return axios.delete(`/v1/folders/${folderId}/group-files`)
}

export default deletePersonaFolderGroup
